import React from 'react';
import clazz from 'classnames';
import { Tabs } from 'antd';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import TabHeader from './TabHeader';
import TabBody from './TabBody';
import './index.less';
import styles from './index.module.less';
const { TabPane } = Tabs;
export default function TabNav(props) {
    const { className, style = {}, title, tabs = [] } = props;
    return (<div className={clazz(styles['tab-nav-wrapper'], className)} style={style}>
      <OverPack playScale={[0.1, 0.5]}>
        <TweenOne.TweenOneGroup key="tabs" enter={{
        y: 30,
        opacity: 0,
        delay: 200,
        type: 'from',
    }} leave={{ y: 30, opacity: 0 }}>
          <header key="header">
            <h1>{title[0]}</h1>
            {title[1] && <p>{title[1]}</p>}
          </header>

          <div key="tab-nav-container" className={clazz('tab-nav-container')}>
            <Tabs defaultActiveKey={tabs[0] && tabs[0].code} tabBarStyle={{ width: 1200, margin: '0 auto' }}>
              {tabs.map((tab) => (<TabPane key={tab.code} tab={<TabHeader tab={tab}/>}>
                  <TweenOne.TweenOneGroup enter={{
        y: 30,
        delay: 300,
        opacity: 0,
        type: 'from',
        ease: 'easeOutQuad',
    }} leave={null} component="">
                    <TabBody tab={tab}/>
                  </TweenOne.TweenOneGroup>
                </TabPane>))}
            </Tabs>
          </div>
        </TweenOne.TweenOneGroup>
      </OverPack>
    </div>);
}
